import React, { useState } from 'react';
import { createCustomer } from '../api';
import useDuplicateCustomerCheck from './useDuplicateCustomerCheck';
import './newcustomer.css';

const NewCustomer = ({ showModal, toggleModal, onCustomerCreated, onExistingCustomerChosen }) => {
  const { confirmNewCustomer, duplicatePrompt } = useDuplicateCustomerCheck();
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    address: '',
    notes: ''
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);

    try {
      const choice = await confirmNewCustomer(formData);
      if (!choice) return; // back to the form
      if (choice.action === 'use') {
        if (onExistingCustomerChosen) onExistingCustomerChosen(choice.customer);
        toggleModal();
        return;
      }
      const newCustomer = await createCustomer(formData);
      onCustomerCreated(newCustomer);
      toggleModal();
    } catch (err) {
      setError('Failed to create customer. Please try again.');
      console.error('Error creating customer:', err);
    } finally {
      setIsLoading(false);
    }
  };

  if (!showModal) return null;

  return (
    <div className="newcustomer-overlay">
      <div className="newcustomer-modal">
        <div className="newcustomer-header">
          <h2>New Customer</h2>
          <button className="newcustomer-close" onClick={toggleModal}>×</button>
        </div>

        <form onSubmit={handleSubmit} className="newcustomer-form">
          <div className="newcustomer-row">
            <div className="newcustomer-field">
              <label htmlFor="name">Name *</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                required
              />
            </div>
            <div className="newcustomer-field">
              <label htmlFor="phone">Phone</label>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleInputChange}
              />
            </div>
          </div>

          <div className="newcustomer-field">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
            />
          </div>

          <div className="newcustomer-field">
            <label htmlFor="address">Address</label>
            <textarea
              id="address"
              name="address"
              value={formData.address}
              onChange={handleInputChange}
              rows="2"
            />
          </div>

          <div className="newcustomer-field">
            <label htmlFor="notes">Notes</label>
            <textarea
              id="notes"
              name="notes"
              value={formData.notes}
              onChange={handleInputChange}
              rows="2"
            />
          </div>

          {error && <div className="newcustomer-error">{error}</div>}

          <div className="newcustomer-actions">
            <button type="button" onClick={toggleModal} disabled={isLoading}>
              Cancel
            </button>
            <button type="submit" disabled={isLoading}>
              {isLoading ? 'Creating...' : 'Create'}
            </button>
          </div>
        </form>
      </div>
      {duplicatePrompt}
    </div>
  );
};

export default NewCustomer;
